import { ChangeDetectorRef, Component, inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { autoEnrolamientoService } from './autoEnrolamiento.service';
import { AppModule } from '../../app-module';
import { ListaArchivosComponent } from '../../commons/components/downLoadFile/lista-archivos/lista-archivos.component';
import { LoaderComponent } from '../../commons/components/loader/loader.component';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { BaseReponseGeneric } from '../../commons/class/BaseReponseGeneric.interface';
import { GetTypeOrganismDTO, insertPostAutoEnrolamiento } from './autoEnrolamiento.interface';
import { Observable, Subject, concat, of, distinctUntilChanged, tap, switchMap, catchError } from 'rxjs';
import { ModalIframeService } from '../../commons/components/modal-iframe/modal-iframe.service';
import { AuthService } from '../../commons/services/auth.service';
import { Documents } from '../../commons/class/archivo.inteface';
import { ElectronicDemandService } from '../demanda/electronicDemand.service';
import { AlertService } from '../../commons/components/alert/alert.service';
import { AlertComponent } from '../../commons/components/alert/alert.component';
import { v4 as uuidv4 } from 'uuid';
import { ConfirmationDialogService } from '../../commons/components/confirm-dialog/confirm-dialog.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { TextualComponent } from "cjf.sise.web.captcha-lib";
import { ENV_TOKEN } from '../../app-module.token';
import { FirmadorService } from '../../commons/shared/firmador.service';
import { SessionStorageService } from '../../commons/services/sessionl-storage.service';
import { IpService } from '../../commons/services/ipService.service';

@Component({
    selector: 'oaj-auto-enrolamiento-itx',
    templateUrl: 'autoEnrolamiento.component.html',
    providers: [autoEnrolamientoService, ConfirmationDialogService],
    imports: [AppModule, ListaArchivosComponent, LoaderComponent, AlertComponent, TextualComponent],
    styleUrls: ['./autoEnrolamiento.component.css']
})

export class autoEnrolamientoComponent implements OnInit {

    private service: autoEnrolamientoService = inject(autoEnrolamientoService);
    private modalIframeService: ModalIframeService = inject(ModalIframeService);
    private authService: AuthService = inject(AuthService);
    private _serviceElectronicDemand: ElectronicDemandService = inject(ElectronicDemandService);
    private alertService: AlertService = inject(AlertService);
    private fb: FormBuilder = inject(FormBuilder);
    private router: Router = inject(Router);
    private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
    private ngZone: NgZone = inject(NgZone);
    private modalConfirmacionService: ConfirmationDialogService = inject(ConfirmationDialogService);
    readonly environment = inject(ENV_TOKEN);
    private firmador = inject(FirmadorService);
    private ipService = inject(IpService);
    private sessionStorageService: SessionStorageService = inject(SessionStorageService);

    private ip = '';

    constructor() {
        this.constService = this.environment;
        this.formAutoE = this.fb.group({
            'dependencia': [{ value: null, disabled: this.formDesabilitar }, [Validators.required]],
            //'autoridad': [{ value: '', disabled: this.formDesabilitar }, [Validators.required]],
            'autoridad': this.fb.control({ value: '', disabled: this.formDesabilitar }, {
                validators: [Validators.required, Validators.maxLength(500)],
                //updateOn: 'blur' // Set updateOn to blur for this specific control
            }),
            'solicitante': [{ value: '', disabled: this.formDesabilitar }, [Validators.required, Validators.maxLength(500)]],
            'correoInstitucion': [{ value: '', disabled: this.formDesabilitar }, [Validators.required, Validators.email, Validators.maxLength(100)]],
            'correoSolicitante': [{ value: '', disabled: this.formDesabilitar }, [Validators.required, Validators.email, Validators.maxLength(100)]],
            'telSolicitante': [{ value: '', disabled: this.formDesabilitar }, [Validators.required, Validators.maxLength(50)]],
            'observaciones': [{ value: '', disabled: this.formDesabilitar }, [Validators.maxLength(5000)]],

        }, {
            validators: correosDiferentesValidator()
        });
    }
    getForm() {
        return this.formAutoE.value;
    }
    docFirmados(): boolean {
        return this.lstDocumentos.find(x => x.firmado == false) == undefined;
    }
    getPalabraInvalida(): boolean {
        return this.formAutoE.controls['autoridad'].hasError('wordAutoEnromientoValidacion');
    }

    trackByFn(item: GetTypeOrganismDTO) {
        return item.catTipoOrganismoId;
    }
    isLoadingFile = false;
    public lstDocumentos: any[] = [];
    sMensajeLoad = "Consultando archivos...";
    sMensajeLoading = "Guardando...";
    formAutoE: FormGroup;
    uuid = '0';
    submitted = false;
    loading = false;
    catDeploading = false;
    private constService: any;
    formDesabilitar = false;
    captchaValido = false;
    captchaId = '';
    @ViewChild('captchaComponent') childCaptcha!: TextualComponent;

    catDep$!: Observable<BaseReponseGeneric<GetTypeOrganismDTO[]>>;
    //catDepVacio$: BaseReponseGeneric<GetTypeOrganismDTO[]> = {data:[],message:'',succcess:false};
    catDepInput$ = new Subject<string>();
    //catValidarPalabras$!: Observable<BaseReponseGeneric<catValidarPalabras[]>>;
    bAcceptDocx = false;
    sFormatos = 'PDF';

    ngOnInit() {
        if (this.bAcceptDocx) {
            this.sFormatos = 'PDF, DOCX';
        }
        else {
            this.sFormatos = 'PDF'
        }
        //this.catDep$ = this.cargarDependencias();
        this.cargarDependencias();
        this.uuid = uuidv4();

        this.ipService.getIPAddressPromise().then(
            (response) => {
                this.ip = response;
            }
        );
    }

    /**
     * Funcion para cargar las dependencias en el select, se hace una consulta al servicio para obtener las dependencias dependiendo del termino de busqueda, se muestra un mensaje de error si ocurre un error durante la consulta
     */
    cargarDependencias() {
        this.catDep$ = concat(
            of({ data: [], message: '', succcess: false }),
            this.catDepInput$.pipe(
                distinctUntilChanged(),
                tap(() => (this.catDeploading = true)),
                switchMap((term) =>
                    this.service.getDependenciasOrg(term).pipe(
                        catchError(() => of({ data: [], message: '', succcess: false })),
                        tap(() => (this.catDeploading = false)),
                    ),
                ),
            ),
        );
    }


    /**
     * Funcion para abrir la modal de carga de archivos, se construye la url para la firma de los documentos dependiendo del usuario y la pantalla, se muestra un mensaje de error si ocurre un error al abrir la modal o durante la consulta de los documentos cargados
     */
    cargaArchivo() {

        const IdPantalla = 0;
        const TipoArchivo = this.constService.TipoDoctos.autoEnrolamiento;
        const FirmaObligatoria = 1;
        const urlFirma = `${this.constService.baseUrlFirma}?userName=autoEnrolamiento&idUser=52238&idOrganismo=3&IdSystem=1&IdPantalla=${IdPantalla}&IdTransaction=${this.uuid}&tipoArchivo=${TipoArchivo}&fo=${FirmaObligatoria}&ma=1`;
        // console.log('urlfirma', urlFirma);
        this.modalIframeService.open('Carga de documentos',
            urlFirma,
            'Cerrar',
            'xl').then((closed) => {
                if (closed) {
                    this.isLoadingFile = true;
                    this.GetDocumentosPantalla(this.uuid).then((resolve) => {
                        this.lstDocumentos = resolve;

                    }).finally(() => {
                        this.isLoadingFile = false;
                        this.cdr.detectChanges();
                    });
                }
            }).catch(() => console.error('Ocurrio un error con la modal de iframe'));
    }

    /**
     * Funcion para eliminar un documento cargado, se muestra una modal de confirmacion antes de eliminar el documento, se muestra un mensaje de error si ocurre un error durante la eliminacion o durante la consulta de los documentos cargados despues de la eliminacion
     * @param Documento 
     */
    EliminarDocumentosPantalla(Documento: any): void {
        this.modalConfirmacionService.confirm('Confirmación',
            'Va eliminar el documento con nombre original ' + Documento.NombreOriginal + ', ¿desea continuar?',
            'Aceptar',
            'Cancelar',
            'sm').then((confirmed) => {
                if (confirmed) {
                    this.service.EliminarDocumentosPantalla(Documento.IdDocumento).subscribe({
                        next: (response: any) => {
                            if (response.succcess) {
                                this.isLoadingFile = true;
                                this.alertService.success("Se eliminó correctamente el documento", { autoClose: true, keepAfterRouteChange: false });
                                this.GetDocumentosPantalla(this.uuid).then((resolve) => {
                                    this.lstDocumentos = resolve;
                                }).finally(() => {
                                    this.isLoadingFile = false;
                                    this.cdr.detectChanges();
                                });
                            }
                        },
                        error: (error) => {
                            this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
                            return;
                        }
                    });
                }
            })
            .catch(() => console.error('Ocurrio un error con la modal de confirmación'))
            .finally(() => {
                //this.isLoadingFile = false;
            });
    }

    /**
     * Funcion para manejar el envio del formulario, se valida que se hayan llenado todos los campos requeridos, que se haya cargado por lo menos un documento, que los documentos cargados esten firmados y que se haya validado el captcha, se muestra una modal de confirmacion antes de enviar la solicitud, se muestra un mensaje de error si no se cumplen las validaciones o si ocurre un error durante el envio de la solicitud
     * @returns 
     */
    onSubmit() {
        this.submitted = true;
        if (!this.formAutoE.valid) {
            this.formAutoE.markAllAsTouched();
            this.alertService.error('Validar formulario', { autoClose: true, keepAfterRouteChange: false });
            return;
        }

        if (this.lstDocumentos.length == 0) {
            this.formAutoE.markAllAsTouched();
            this.alertService.error('Agregar por lo menos un documento', { autoClose: true, keepAfterRouteChange: false });
            return;
        }

        if (!this.docFirmados()) {
            this.formAutoE.markAllAsTouched();
            this.alertService.error('Firmar los documentos', { autoClose: true, keepAfterRouteChange: false });
            return;
        }

        if (!this.captchaValido) {
            this.formAutoE.markAllAsTouched();
            this.alertService.error('Validar captcha', { autoClose: true, keepAfterRouteChange: false });
            return;
        }

        this.modalConfirmacionService.confirm('Autoenrolamiento', '¿Está seguro de enviar la solicitud?', 'Confirmar', 'Cancelar').then((c) => {
            if (c) {
                const objSend: insertPostAutoEnrolamiento = {
                    fkIdCatTipoOrganismo: this.formAutoE.controls['dependencia'].value,
                    correoInstitucion: this.formAutoE.controls['correoInstitucion'].value,
                    autoridad: this.formAutoE.controls['autoridad'].value,
                    observaciones: this.formAutoE.controls['observaciones'].value,
                    sGUID: this.uuid,
                    solicitante: this.formAutoE.controls['solicitante'].value,
                    telSolicitante: this.formAutoE.controls['telSolicitante'].value,
                    correoSolicitante: this.formAutoE.controls['correoSolicitante'].value,
                    idCaptcha: this.captchaId,
                    sIP: this.ip
                }
                this.loading = true;
                this.service.postRegistrar(objSend)
                    .subscribe({
                        next: (response: BaseReponseGeneric<number>) => {
                            if (response && response.succcess) {
                                //mandar actualizar el id transaction por el guid
                                this.service.updateIdTransaction(this.uuid, response.data).subscribe((r: BaseReponseGeneric<boolean>) => {
                                    if (r && r.succcess) {
                                        // Limpiar formulario y datos antes de mostrar el modal
                                        this.limpiarFormulario();
                                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                        this.modalConfirmacionService.confirm('Registro de autoridad', objSend.solicitante + ', se envió correo electrónico a la cuenta indicada de la autoridad (' + objSend.correoInstitucion + '), con instrucciones para continuar con la solicitud de alta.', 'Aceptar', '', 'lg').then((confirm) => {
                                            //this.router.navigateByUrl('https://www.oaj.gob.mx/interconexion/');
                                            
                                            // si es localhost no redireccionar
                                            if (window.location.hostname !== 'localhost') {
                                                window.location.replace("https://www.oaj.gob.mx/interconexion/");
                                            }
                                        });
                                    }
                                    else {
                                        this.modalConfirmacionService.confirm('Registro de autoridad', r.message, 'Aceptar', '');
                                        this.captchaValido = false;
                                        this.captchaId = '';
                                    }

                                    this.loading = false;
                                });
                            }
                            else {
                                this.modalConfirmacionService.confirm('Registro autoridad', response.message, 'Aceptar', '');
                                this.captchaValido = false;
                                this.captchaId = '';
                            }
                        },
                        error: (error: HttpErrorResponse) => {
                            this.modalConfirmacionService.confirm('Validación correo', error.error.message, 'Aceptar', '');
                            this.loading = false;
                            this.captchaValido = false;
                            this.captchaId = '';
                        },
                        complete: () => {
                            this.loading = false;
                        }
                    });
            }
        });
    }

    /**
     * Funcion para manejar la respuesta del captcha, se valida que la respuesta sea correcta para habilitar el envio del formulario, se muestra un mensaje de error si la respuesta del captcha es incorrecta o si ocurre un error durante la validacion del captcha
     * @param respuesta 
     */
    respuestaCaptcha(respuesta: boolean) {
        //console.log(respuesta);
        if (respuesta) {
            this.captchaId = this.childCaptcha.captchaId;
            this.captchaValido = true;
        }

        //this.cdr.detectChanges();
    }

    /**
     * Funcion para cargar los documentos cargados en la pantalla, se hace una consulta al servicio para obtener los documentos dependiendo del guid generado para la transaccion, se muestra un mensaje de error si ocurre un error durante la consulta de los documentos
     * @param uuid 
     * @returns 
     */
    public GetDocumentosPantalla(uuid: string): Promise<Documents[]> {

        return new Promise((resolve) => {
            this._serviceElectronicDemand.getDocumentosPantallaGuid(uuid)
                .subscribe((response: Documents[]) => {
                    if (response.length > 0) {
                        resolve(response);
                    }
                    else {
                        resolve([]);
                    }
                }, (error: any) => {
                    this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
                    resolve([]);
                });

        });
    }

    async openWindowFirma(): Promise<void> {
        if (this.uuid === "0") {
            this.uuid = uuidv4();
        }

        this.isLoadingFile = true;
        try {
            const signCompletedData = await this.firmador.openWindowFirma(this.uuid, this.constService.TipoDoctos.autoEnrolamiento, this.bAcceptDocx);
            this.ngZone.run(() => {
                this.lstDocumentos = Array.isArray(signCompletedData) ? [...signCompletedData] : [];
            });
        } finally {
            this.ngZone.run(() => {
                this.isLoadingFile = false;
                this.cdr.detectChanges();
            });
        }
    }

    private limpiarFormulario(): void {
        // Resetear formulario
        this.formAutoE.reset();

        // Limpiar lista de documentos
        this.lstDocumentos = [];

        // Resetear variables de estado
        this.submitted = false;
        this.captchaValido = false;
        this.captchaId = '';
        this.sessionStorageService.clear();
        // Forzar detección de cambios
        this.cdr.detectChanges();
    }

}


export function correosDiferentesValidator(): ValidatorFn {
    return (form: AbstractControl): ValidationErrors | null => {
        const correoInstitucion = form.get('correoInstitucion')?.value?.trim().toLowerCase();
        const correoSolicitante = form.get('correoSolicitante')?.value?.trim().toLowerCase();

        if (
            correoInstitucion &&
            correoSolicitante &&
            correoInstitucion === correoSolicitante
        ) {
            return { correosIguales: true };
        }

        return null;
    };
}
